(self["webpackChunk_N_E"] = self["webpackChunk_N_E"] || []).push([[38],{

/***/ 2812:
/***/ (function(__unused_webpack_module, __unused_webpack_exports, __webpack_require__) {


    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/legal/[slug]",
      function () {
        return __webpack_require__(3755);
      }
    ]);
    if(false) {}
  

/***/ }),

/***/ 699:
/***/ (function(__unused_webpack_module, __webpack_exports__) {

"use strict";
/* harmony default export */ __webpack_exports__["Z"] = ({"src":"/_next/static/media/default-splash-card.0ded0b20.png","height":1667,"width":1667,"blurDataURL":"data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAAgAAAAICAIAAABLbSncAAAAqElEQVR42iWOOQrCABBF5wiC4lKIW+GWmEWSVo8QUAhoE21SBtLmDIE0aXOAtDmC1mlyn4cZhAczzPzP/4JhYjs4Lu5Zl5OFeeoRHZMZgyEizBcslmx3/Vs4GjyevN4kCbc7QcDlym4veD5VRdPQddQ1aUoUsVqLGsNQhWVJ2/L5kueIiKatN4iQZRSFXuOY0Vi0lWVrq/0BEWU8xXa01R+1en6PigzzB2D/YcmSCI2wAAAAAElFTkSuQmCC","blurWidth":8,"blurHeight":8});

/***/ }),

/***/ 3065:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "Z": function() { return /* binding */ CustomHead; }
/* harmony export */ });
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(5893);
/* harmony import */ var next_head__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(9008);
/* harmony import */ var next_head__WEBPACK_IMPORTED_MODULE_1___default = /*#__PURE__*/__webpack_require__.n(next_head__WEBPACK_IMPORTED_MODULE_1__);
/* harmony import */ var next_router__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(1163);
/* harmony import */ var next_router__WEBPACK_IMPORTED_MODULE_2___default = /*#__PURE__*/__webpack_require__.n(next_router__WEBPACK_IMPORTED_MODULE_2__);
/* harmony import */ var _assets_img_default_splash_card_png__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(699);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(7294);





const baseUrl = "https://www.casperlabs.io/";
const siteName = "Casper Labs";
function CustomHead(param) {
    let { title , description ="" , og , twitter , business , children  } = param;
    if (!og) {
        og = {
            ogTitle: title,
            ogDescription: description,
            ogImage: _assets_img_default_splash_card_png__WEBPACK_IMPORTED_MODULE_3__/* ["default"].src */ .Z.src
        };
    }
    const router = (0,next_router__WEBPACK_IMPORTED_MODULE_2__.useRouter)();
    const key = (0,react__WEBPACK_IMPORTED_MODULE_4__.useId)();
    const ogUrl = "".concat(baseUrl.substring(0, baseUrl.length - 1)).concat(router.asPath);
    return(// eslint-disable-next-line @next/next/no-script-component-in-head
    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)((next_head__WEBPACK_IMPORTED_MODULE_1___default()), {
        children: [
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("link", {
                rel: "icon",
                type: "image/x-icon",
                href: "/favicon.ico"
            }),
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("link", {
                rel: "icon",
                type: "image/png",
                sizes: "192x192",
                href: "/android-chrome-192x192.png"
            }),
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("link", {
                rel: "icon",
                type: "image/png",
                sizes: "512x512",
                href: "/android-chrome-512x512.png"
            }),
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("link", {
                rel: "preload",
                href: "".concat(baseUrl, "icons/navbar-toggle-icon.webp"),
                as: "image"
            }),
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("title", {
                children: title
            }),
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("meta", {
                name: "author",
                content: "Casper Labs"
            }),
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("meta", {
                name: "description",
                content: description
            }),
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("meta", {
                name: "googlebot",
                content: "all"
            }),
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("meta", {
                name: "bingbot",
                content: "all"
            }),
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("meta", {
                name: "robots",
                content: "all"
            }),
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("meta", {
                name: "facebook-domain-verification",
                content: "5dpoinx6gwzawxktv7aakmzim1f23c"
            }),
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("meta", {
                property: "og:site_name",
                content: siteName
            }),
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("meta", {
                property: "og:image:width",
                content: "1200"
            }),
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("meta", {
                property: "og:image:height",
                content: "630"
            }),
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("meta", {
                property: "og:title",
                content: og.ogTitle
            }),
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("meta", {
                property: "og:description",
                content: og.ogDescription
            }),
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("meta", {
                property: "og:type",
                content: "website"
            }),
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("meta", {
                property: "og:url",
                content: ogUrl
            }),
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("meta", {
                property: "og:image",
                content: og.ogImage
            }),
            twitter && Object.keys(twitter).map((p)=>{
                const content = twitter[p];
                return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("meta", {
                    name: "twitter:".concat(p),
                    content: content
                }, key + p);
            }),
            business && Object.keys(business).map((p)=>{
                const content = business[p];
                return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("meta", {
                    property: "business:contact_data:".concat(p),
                    content: content
                }, key + p);
            }),
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("link", {
                rel: "canonical",
                href: ogUrl
            }),
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("link", {
                rel: "manifest",
                href: "/manifest.json"
            }),
            children
        ]
    }));
}


/***/ }),

/***/ 3755:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
// ESM COMPAT FLAG
__webpack_require__.r(__webpack_exports__);

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "__N_SSP": function() { return /* binding */ __N_SSP; },
  "default": function() { return /* binding */ Legal; }
});

// EXTERNAL MODULE: ./node_modules/react/jsx-runtime.js
var jsx_runtime = __webpack_require__(5893);
// EXTERNAL MODULE: ./node_modules/react-bootstrap/esm/Container.js
var Container = __webpack_require__(682);
// EXTERNAL MODULE: ./node_modules/react-bootstrap/esm/Row.js
var Row = __webpack_require__(4051);
// EXTERNAL MODULE: ./node_modules/react-bootstrap/esm/Col.js
var Col = __webpack_require__(1555);
// EXTERNAL MODULE: ./src/modules/legal/components/LegalDetail/LegalDetail.module.scss
var LegalDetail_module = __webpack_require__(3056);
var LegalDetail_module_default = /*#__PURE__*/__webpack_require__.n(LegalDetail_module);
;// CONCATENATED MODULE: ./src/modules/legal/components/LegalDetail/LegalDetail.tsx



function LegalDetail(param) {
    let { doc  } = param;
    var _body;
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)("section", {
        className: "legalDetail",
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsx)(Container/* default */.Z, {
                fluid: true,
                className: (LegalDetail_module_default()).containerBg,
                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Container/* default */.Z, {
                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Row/* default */.Z, {
                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Col/* default */.Z, {
                            sm: {
                                span: 10,
                                offset: 1
                            },
                            md: {
                                span: 8,
                                offset: 2
                            },
                            children: /*#__PURE__*/ (0,jsx_runtime.jsx)("h2", {
                                className: "mb-5",
                                children: doc.title
                            })
                        })
                    })
                })
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)(Container/* default */.Z, {
                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Row/* default */.Z, {
                    className: "mt-8 pt-3",
                    children: /*#__PURE__*/ (0,jsx_runtime.jsxs)(Col/* default */.Z, {
                        sm: {
                            span: 10,
                            offset: 1
                        },
                        md: {
                            span: 8,
                            offset: 2
                        },
                        children: [
                            /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                className: "body",
                                dangerouslySetInnerHTML: {
                                    __html: (_body = doc.body) !== null && _body !== void 0 ? _body : ""
                                }
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsx)("hr", {
                                className: "lineBodyEnd"
                            })
                        ]
                    })
                })
            })
        ]
    });
}

// EXTERNAL MODULE: ./node_modules/react-query/es/index.js
var es = __webpack_require__(8767);
// EXTERNAL MODULE: ./src/@shared/service/cms-api.ts + 1 modules
var cms_api = __webpack_require__(7746);
// EXTERNAL MODULE: ./node_modules/react/index.js
var react = __webpack_require__(7294);
;// CONCATENATED MODULE: ./src/@shared/hooks/useFadeInAnimation.ts

function useFadeInAnimation(timeout) {
    const [showFadeIn, setfadeInVisible] = (0,react.useState)(false);
    const [showBackground, setShowBackground] = (0,react.useState)(false);
    const handleStartAnimation = ()=>{
        setfadeInVisible(true);
        setShowBackground(true);
        setTimeout(()=>{
            setfadeInVisible(false);
        }, timeout);
    };
    (0,react.useEffect)(()=>{
        handleStartAnimation();
    }, []);
    return {
        showFadeIn,
        showBackground
    };
}

// EXTERNAL MODULE: ./src/@shared/components/head/customHead/customHead.tsx
var customHead = __webpack_require__(3065);
;// CONCATENATED MODULE: ./src/pages/legal/[slug].tsx






const initialArgs = {
    sort: "position",
    limit: 0,
    page: 1
};
var __N_SSP = true;
function Legal(param) {
    let { slug  } = param;
    const { data  } = (0,es.useQuery)([
        "legaldocs"
    ], ()=>(0,cms_api/* getLegalDocs */.bf)(initialArgs));
    const legalDocs = data === null || data === void 0 ? void 0 : data.data;
    const doc = legalDocs.find((x)=>x.meta.slug === slug);
    const title = doc ? doc.meta.title : "";
    var _description;
    const description = doc ? (_description = doc.meta.description) !== null && _description !== void 0 ? _description : "" : "";
    const og = {
        ogTitle: title,
        ogDescription: description
    };
    const { showFadeIn , showBackground  } = useFadeInAnimation(1000);
    const pageClass = "legalPage ".concat(showBackground ? "d-block" : "d-none", " ").concat(showFadeIn ? "fadeIn" : "");
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
        className: pageClass,
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsx)(customHead/* default */.Z, {
                title: title,
                description: description,
                og: og
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("main", {
                children: doc && /*#__PURE__*/ (0,jsx_runtime.jsx)(LegalDetail, {
                    doc: doc
                })
            })
        ]
    });
}


/***/ }),

/***/ 3056:
/***/ (function(module) {

// extracted by mini-css-extract-plugin
module.exports = {"containerBg":"LegalDetail_containerBg__wLSVV","mobilePaddingX":"LegalDetail_mobilePaddingX__dfcDu"};

/***/ }),

/***/ 9008:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

module.exports = __webpack_require__(3121)


/***/ })

},
/******/ function(__webpack_require__) { // webpackRuntimeModules
/******/ var __webpack_exec__ = function(moduleId) { return __webpack_require__(__webpack_require__.s = moduleId); }
/******/ __webpack_require__.O(0, [774,888,179], function() { return __webpack_exec__(2812); });
/******/ var __webpack_exports__ = __webpack_require__.O();
/******/ _N_E = __webpack_exports__;
/******/ }
]);